const colors = require('colors/safe');

export function noLint_console(level: unknown, message: unknown): void {
  if (level === 'error') console.error(message);
  else console.log(message);
}

export function noLint_stringify(o: unknown): string | null {
  if (typeof o === 'object') {
    try {
      return JSON.stringify(o);
    } catch (e) {
      return null;
    }
  }
  return String(o);
}

export function noLint_getColor(
  color: 'green' | 'yellow' | 'red' | 'magenta' | 'grey',
): (v: string) => string {
  return colors[color];
}
